module.exports = __webpack_public_path__ + "img/play.019913eb.png";